// extracted by mini-css-extract-plugin
export default {"melodyVideo":"MP-z","isFullWidth":"NP-z","landingPageVideo":"OP-z","play":"PP-z","iframeVideo":"QP-z","playHidden":"RP-z","fullwidth":"SP-z"};